/**
 * Captures transport-level failures with stacks so we can see WHICH code path threw
 * (fetch vs axios vs dynamic import vs extension), not just the generic message.
 */
function summarizeReason(reason) {
  if (reason == null) return { type: 'null' };
  if (typeof reason === 'string') return { type: 'string', message: reason };
  if (typeof reason === 'object') {
    return {
      type: reason.name || 'Error',
      message: reason.message,
      stack: reason.stack,
      code: reason.code,
      status: reason.status,
    };
  }
  return { type: typeof reason, value: String(reason) };
}

function install() {
  window.addEventListener('unhandledrejection', (event) => {
    const r = event.reason;
    const msg = r && (r.message != null ? String(r.message) : String(r));
    if (!msg) return;
    if (/Failed to fetch|NetworkError|ERR_NETWORK|Load failed|Network Error|timeout/i.test(msg)) {
      console.error('[TRANSPORT_DIAG:unhandledrejection]', {
        message: msg,
        ...summarizeReason(r),
        timestamp: new Date().toISOString(),
        hint: 'Check stack: userInfo (fetch), dynamic import/chunk, service worker, or extension if stack is empty.',
      });
    }
  });

  window.addEventListener('error', (event) => {
    const m = event?.message || '';
    if (/Failed to fetch|Loading chunk \d+ failed/i.test(m)) {
      console.error('[TRANSPORT_DIAG:window.error]', {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error,
        timestamp: new Date().toISOString(),
      });
    }
  });
}

install();
